import { render } from "./GroupMktReport.vue?vue&type=template&id=4a8c30b4"
import script from "./GroupMktReport.vue?vue&type=script&lang=js"
export * from "./GroupMktReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__